// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".SuggestionContent{display:grid;position:relative;grid-gap:2rem;gap:2rem;grid-template-columns:100%}@media screen and (min-width:1024px){.SuggestionContent{grid-template-columns:360px 1fr}}.hide-transition:before{background:linear-gradient(180deg,hsla(0,0%,96%,.01) 70%,#f6f6f6);content:\"\";height:100%;position:absolute;width:100%;z-index:100}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
